<ion-card>
  <ion-card-header>
    <ion-card-title [routerLink]="'/profile/'+author">
      <username [username]="author"></username>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    {{text}}<br>
  </ion-card-content>
  <ion-item>
    <ion-label class="date">{{date|dateTimeFormat}}</ion-label>
    <ion-button *ngIf="showDeleteButton" (click)="onDelete.emit()" fill="clear" size="small" slot="end">
      <ion-icon name="trash-outline" slot="start"></ion-icon>
      {{'shared.delete' | translate}}
    </ion-button>
  </ion-item>
</ion-card>